<template>
  <div class="min-h-screen w-full overflow-x-hidden mx-auto">
    <Inicio id="inicio" />
    <Proyectos id="proyectos" />
    <Certificados />
    <AcercaDeMi id="sobre-mi" />
    <Contactame id="contactame" />
  </div>
</template>
